const formatDate = (dateString: string): string => {
  const date = new Date(dateString)

  // Obtenir le jour, le mois et l'année
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // getMonth() retourne 0-11
  const year = date.getFullYear()

  // Retourner la date formatée
  return `${day}/${month}/${year}`
}

export default formatDate
